import { CommonModule } from '@angular/common';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideToastr } from 'ngx-toastr';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

// Services
import { ProfileService } from '../../services/profile.service';
import { TfaManageService } from '../../services/tfamanage.service';
import { DataSharingService } from '../../services/data-sharing.service';
import { ProjectService } from '../../services/projects.service';
import { FilterService } from '../../services/filters.service';
import { GeometryService } from '../../services/geometries.service';
import { UploadImportedService } from '../../services/imported.service';
import { PermissionJWTService } from '../../services/permission_jwt.service';
import { MapSideBarService } from '../../pages/project/map/map-sidebar/map-sidebar.service';
import { MapToolBarService } from '../../pages/map-toolbar/map-toolbar.service';
import { MapService } from '../../services/map.service';
import { OperationManagementService } from '../../pages/project/map/map-sidebar/operations/operation_management/operation-management.service';

// Guards
import { AuthGuard } from '../../guards/auth/auth.guard';
import { AdminGuard } from '../../guards/admin/admin.guard';
import { MasterGuard } from '../../guards/master/master.guard';
import { CommonGuard } from '../../guards/common/user.guard';

// Interceptors
import { LoadingInterceptor } from '../../interceptors/loading.interceptor';

// Keycloak
import { AutoRefreshTokenService, UserActivityService, provideKeycloak } from 'keycloak-angular';
import { environment } from '../../../environments/environment';
import { NatService } from '../../services/nat.service';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    MatProgressSpinnerModule,
  ],
  providers: [
    // Services
    ProfileService,
    TfaManageService,
    DataSharingService,
    ProjectService,
    FilterService,
    GeometryService,
    UploadImportedService,
    PermissionJWTService,
    MapSideBarService,
    MapToolBarService,
    OperationManagementService,
    MapService,
    NatService,

    // Guards
    AuthGuard,
    AdminGuard,
    MasterGuard,
    CommonGuard,

    provideAnimations(), // Substitui BrowserAnimationsModule
    provideToastr({
      timeOut: 3000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }),

    // Interceptors
    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },

    // Keycloak and HttpClient setup
    provideHttpClient(withInterceptorsFromDi()),
    provideKeycloak({
      config: {
        url: environment.KEYCLOAK_URL,
        realm: 'eyeforest',
        clientId: 'app-home'
      },
      initOptions: {
        pkceMethod: 'S256',
        onLoad: 'check-sso',
        scope: 'openid profile email',
        silentCheckSsoRedirectUri:
          window.location.origin + '/assets/silent-check-sso.html'
      },
      providers: [AutoRefreshTokenService, UserActivityService]
    }),
  ],
  exports: [
    MatProgressSpinnerModule
  ]
})
export class CoreModule { }
